// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-wrapper {
  position: relative;
}

input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
}

label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}

.select-wrapper {
  position: relative;
  display: block;
}

.inp-wrapper {
  width: 260px;
}

.input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}

select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}

.pgmlistdropdown_textfield {
  display: flex;
  justify-content: space-between;
  width: 97%;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  background: #ffffff;
  border: 1px solid #c1c6d0;
  border-radius: 6px;
  margin: 1rem auto;
  padding: 0.6rem;
}

.partlistdropdowndiv_select {
  width: 16.25vw !important;
}

.partlistdropdowndiv_input {
  width: 98% !important;
}

.div_flex {
  display: flex;
  width: 50%;
}

.partlistdropdowndiv {
  width: 100%;
}

.button_search_part {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
  width: 9.16vw !important;
  height: 2.5rem;
  text-align: center;
  justify-content: center;
  border: none;
  margin: 0.6rem 1rem;
}

.button_search_part:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}

@media screen and (max-width: 1200px) {
  .pgmlistdropdown_textfield {
    column-gap: 20px;
  }
}
@media screen and (max-width: 790px) {
  .input-wrapper {
    width: 100%;
  }
  .div_flex {
    width: 100%;
  }
}
@media screen and (max-width: 480px) {
  .button_search_part {
    width: fit-content !important;
  }
  label {
    font-size: 10px !important;
  }
  .div_flex {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PartslistTextfieldComponent/Partlisttextfield.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,cAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAIA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AADF;;AAGA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AAAF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAMA;EACE,yBAAA;AAHF;;AAKA;EACE,qBAAA;AAFF;;AAIA;EACE,aAAA;EAEA,UAAA;AAFF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,mEAAA;EACA,8CAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,mEAAA;AAHF;;AAMA;EAQE;IACE,gBAAA;EAVF;AACF;AAaA;EAEE;IACE,WAAA;EAZF;EAcA;IACE,WAAA;EAZF;AACF;AAeA;EAIE;IACE,6BAAA;EAhBF;EAkBA;IACE,0BAAA;EAhBF;EAkBA;IACE,WAAA;EAhBF;AACF","sourcesContent":[".input-wrapper {\n  position: relative;\n}\n\ninput {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  width: 92%;\n  height: 2.3rem;\n  margin: 10px;\n  line-height: 6ex;\n}\n\nlabel {\n  position: absolute;\n  top: 0.2ex;\n  z-index: 1;\n  left: 2em;\n  background-color: white;\n  padding: 0 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 14px;\n  color: #0c3688;\n}\n\n.select-wrapper {\n  position: relative;\n  display: block;\n}\n.inp-wrapper{\n  width: 260px;\n}\n// .inpu-wrapper{\n//   width: 525px;\n//   margin-left: -130px;\n// }\n.input::placeholder {\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  color: #10132e;\n}\nselect {\n  border: 1px solid gray;\n  border-radius: 6px;\n  position: relative;\n  margin: 10px;\n  line-height: 6ex;\n  width: 94%;\n  height: 2.5rem;\n}\n.pgmlistdropdown_textfield {\n  display: flex;\n  justify-content: space-between;\n  width: 97%;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  background: #ffffff;\n  border: 1px solid #c1c6d0;\n  border-radius: 6px;\n  margin: 1rem auto;\n  padding: 0.6rem;\n}\n\n// .partlistdropdowndiv{\n//   width: 525px;\n// }\n\n.partlistdropdowndiv_select{\n  width: 16.25vw !important;\n}\n.partlistdropdowndiv_input{\n  width: 98% !important;\n}\n.div_flex{\n  display: flex;\n  // flex-wrap: wrap;\n  width: 50%;\n  // justify-content: space-between;\n}\n\n.partlistdropdowndiv{\n  width: 100%;\n}\n\n.button_search_part {\n  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n  border-radius: 5px;\n  font-family: \"Nunito\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  color: #ffffff;\n  width: 9.16vw !important;\n  height: 2.5rem;\n  text-align: center;\n  justify-content: center;\n  border: none;\n  margin: 0.6rem 1rem;\n}\n\n.button_search_part:disabled{\n  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n}\n\n@media screen and (max-width:1200px) {\n  // .inpu-wrapper{\n  //   // width: 100%;\n  //   margin-left: 0;\n  // }\n  // .input-wrapper{\n  //   width: 15rem;\n  // }\n  .pgmlistdropdown_textfield{\n    column-gap: 20px;\n  }\n}\n\n@media screen and (max-width:790px) {\n\n  .input-wrapper{\n    width: 100%;\n  }\n  .div_flex{\n    width: 100%;\n  }\n}\n\n@media screen and (max-width:480px) {\n  // .input-wrapper{\n  //   width: 140% !important;\n  // }\n  .button_search_part{\n    width: fit-content !important;\n  }\n  label{\n    font-size: 10px !important;\n  }\n  .div_flex{\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
